export default "https://cdn-static.gokick.com/assets/f85860d356d81c773b535a0002382fa42e6b6edf/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";